module.exports = "/_next/static/images/loading_20-995acae9044becbd3587ab8b63ece3a3.png";